// preview-lane.engine.ts
import { RowType, Reservation } from "src/app/models";

export type PreviewMap = Record<string, boolean>;
export const keyFor = (id: string, rowType: RowType) => `${id}:${rowType}`;

export function setPreview(
  map: PreviewMap,
  id: string,
  rowType: RowType,
  value: boolean
): PreviewMap {
  return { ...map, [keyFor(id, rowType)]: value };
}
export function clearPreview(map: PreviewMap, id?: string): PreviewMap {
  if (!id) return {};
  const prefix = `${id}:`;
  const next: PreviewMap = {};
  for (const k of Object.keys(map)) if (!k.startsWith(prefix)) next[k] = map[k];
  return next;
}
export function displaySecond(map: PreviewMap, r: Reservation): boolean {
  const v = map[keyFor(r.id, r.rowType)];
  return v !== undefined ? v : !!r.secondPosition;
}
export function filterByLaneWithPreview(
  list: Reservation[],
  rowType: RowType,
  rowId: string,
  showSecond: boolean,
  map: PreviewMap
) {
  return list.filter(
    (r) =>
      r.rowType === rowType &&
      r.rowId === rowId &&
      (displaySecond(map, r) ? showSecond : !showSecond)
  );
}
